:host {
    display: block;
    box-sizing: border-box;
    position: relative;
}

.item-native {
    text-decoration: none;
    color: inherit;
}

/**
 * Adds internal padding to the item
 */
:host(.rs-item--padding) {
    padding: 8px;
}

:host(.rs-item--flex) {
    width: 100%;
}

:host(.rs-item--flex) .item-native {
    display: flex;
    flex-direction: row;
    align-items: center;
}

/**
 * Appearance
 */
:host([appearance='outline']) {
    box-shadow: inset 0 0 0 1px var(--rs-color-light);
    border-radius: 8px;
}

:host([appearance='shadow']) {
    box-shadow: 0 1px 4px rgba(195, 213, 226, 0.50041);
    border-radius: 8px;
}

:host([appearance='none']) {
    box-shadow: none;
    border-radius: 0;
}

/**
 * SLOTS styling
 */
::slotted([slot='start']) {
    margin-right: 7px;
}

::slotted([slot='end']) {
    margin-left: 7px;
}

/**
 * Align Content + Slots
 */
:host([align-content='space-between']) .item-native ::slotted([slot='start']),
:host([align-content='space-between']) .item-native ::slotted([slot='end']),
:host([align-content='space-evenly']) .item-native ::slotted([slot='start']),
:host([align-content='space-evenly']) .item-native ::slotted([slot='end']),
:host([align-content='space-around']) .item-native ::slotted([slot='start']),
:host([align-content='space-around']) .item-native ::slotted([slot='end']) {
    margin: 0;
}


/*noinspection CssUnresolvedCustomProperty*/
:host .item-native.no-flex-gap-support ::slotted(*) {
    --fgp-margin-top: calc(var(--fgp-gap-row));
    --fgp-margin-left: calc(var(--fgp-gap-column));
    margin-top: var(--fgp-margin-top) !important;
    margin-left: var(--fgp-margin-left) !important;
}

/*noinspection CssUnresolvedCustomProperty*/
.no-flex-gap-support {
    --has-fgp: initial;
    --fgp-margin-top: calc(var(--fgp-gap-row, 0px) * -1);
    --fgp-margin-left: calc(var(--fgp-gap-column, 0px) * -1);
    display: flex;
    gap: var(--fgp-gap, 0px);
    margin-top: var(--fgp-margin-top, 0) !important;
    margin-left: var(--fgp-margin-left, 0) !important;
}